import { render, staticRenderFns } from "./AddFriend.vue?vue&type=template&id=54575be5&scoped=true&"
import script from "./AddFriend.vue?vue&type=script&lang=js&"
export * from "./AddFriend.vue?vue&type=script&lang=js&"
import style0 from "./AddFriend.vue?vue&type=style&index=0&id=54575be5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54575be5",
  null
  
)

export default component.exports